import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const FETCH_EDJBA_FILTERLIST = "FETCH_EDJBA_FILTERLIST";
export const FETCH_EDJBA_FILTERLIST_SUCCESS = "FETCH_EDJBA_FILTERLIST_SUCCESS";
export const FETCH_EDJBA_FILTERLIST_FAILED = "FETCH_EDJBA_FILTERLIST_FAILED";

export const FETCH_WIRELINE_ACH = "FETCH_WIRELINE_ACH";
export const FETCH_WIRELINE_ACH_SUCCESS = "FETCH_WIRELINE_ACH_SUCCESS";
export const FETCH_WIRELINE_ACH_FAILED = "FETCH_WIRELINE_ACH_FAILED";

export const FETCH_WIRELINE_PLANCOUNT = "FETCH_WIRELINE_PLANCOUNT";
export const FETCH_WIRELINE_PLANCOUNT_SUCCESS =
  "FETCH_WIRELINE_PLANCOUNT_SUCCESS";
export const FETCH_WIRELINE_PLANCOUNT_FAILED =
  "FETCH_WIRELINE_PLANCOUNT_FAILED";

export const FETCH_WIRELINE_PLAN_CSV = "FETCH_WIRELINE_PLAN_CSV";
export const FETCH_WIRELINE_PLAN_CSV_SUCCESS =
  "FETCH_WIRELINE_PLAN_CSV_SUCCESS";
export const FETCH_WIRELINE_PLAN_CSV_FAILED = "FETCH_WIRELINE_PLAN_CSV_FAILED";

export const FETCH_WIRELINE_ENT_PERF = "FETCH_WIRELINE_ENT_PERF";
export const FETCH_WIRELINE_ENT_PERF_SUCCESS =
  "FETCH_WIRELINE_ENT_PERF_SUCCESS";
export const FETCH_WIRELINE_ENT_PERF_FAILED = "FETCH_WIRELINE_ENT_PERF_FAILED";

export const FETCH_NEW_ACQ = "FETCH_NEW_ACQ";
export const FETCH_NEW_ACQ_SUCCESS = "FETCH_NEW_ACQ_SUCCESS";
export const FETCH_NEW_ACQ_FAILED = "FETCH_NEW_ACQ_FAILED";

export const FETCH_UPGRADE_BY_PRODUCT = "FETCH_UPGRADE_BY_PRODUCT";
export const FETCH_UPGRADE_BY_PRODUCT_SUCCESS =
  "FETCH_UPGRADE_BY_PRODUCT_SUCCESS";
export const FETCH_UPGRADE_BY_PRODUCT_FAILED =
  "FETCH_UPGRADE_BY_PRODUCT_FAILED";

export const FETCH_NEW_ACQ_CSV = "FETCH_NEW_ACQ_CSV";
export const FETCH_NEW_ACQ_CSV_SUCCESS = "FETCH_NEW_ACQ_CSV_SUCCESS";
export const FETCH_NEW_ACQ_CSV_FAILED = "FETCH_NEW_ACQ_CSV_FAILED";

export const FETCH_UPGRADE_CSV = "FETCH_UPGRADE_CSV";
export const FETCH_UPGRADE_CSV_SUCCESS = "FETCH_UPGRADE_CSV_SUCCESS";
export const FETCH_UPGRADE_CSV_FAILED = "FETCH_UPGRADE_CSV_FAILED";

export const FETCH_TIMESTAMP = "FETCH_TIMESTAMP";
export const FETCH_TIMESTAMP_SUCCESS = "FETCH_TIMESTAMP_SUCCESS";
export const FETCH_TIMESTAMP_FAILED = "FETCH_TIMESTAMP_FAILED";

export const SHOW_ALERT_ED1 = "SHOW_ALERT_ED1";
export const HIDE_ALERT_ED1 = "HIDE_ALERT_ED1";

export const TOGGLE_DATE_ALERT = "TOGGLE_DATE_ALERT";
export const TOGGLE_ERROR_ALERT = "TOGGLE_ERROR_ALERT";

export const RESET_ED1 = "RESET_ED1";

export const SET_SELECTED_DATA = "SET_SELECTED_DATA";

export const FETCH_SCHEME_TYPE = "FETCH_SCHEME_TYPE";
export const FETCH_SCHEME_TYPE_SUCCESS = "FETCH_SCHEME_TYPE_SUCCESS";
export const FETCH_SCHEME_TYPE_FAILED = "FETCH_SCHEME_TYPE_FAILED";

export const FETCH_SCHEME_NAME = "FETCH_SCHEME_NAME";
export const FETCH_SCHEME_NAME_SUCCESS = "FETCH_SCHEME_NAME_SUCCESS";
export const FETCH_SCHEME_NAME_FAILED = "FETCH_SCHEME_NAME_FAILED";

export function fetchEdJbaFilterList(obj, callback, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}wireLineJioFiber`,
      dispatch,
      defaultAction: FETCH_EDJBA_FILTERLIST,
      successAction: FETCH_EDJBA_FILTERLIST_SUCCESS,
      failedAction: FETCH_EDJBA_FILTERLIST_FAILED,
      type: "POST",
      //   headers: obj.headers,
      params: obj,
      callback: callback,
      signal: signal,
    };
    makeAPICall(params);
  };
}

export function fetchWirelineAch(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_WIRELINE_ACH,
      successAction: FETCH_WIRELINE_ACH_SUCCESS,
      failedAction: FETCH_WIRELINE_ACH_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      // callback: callback
    };
    makeAPICall(params);
  };
}

export function fetchSchemeName(obj, callback, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutSmbFiber`,
      dispatch,
      defaultAction: FETCH_SCHEME_NAME,
      successAction: FETCH_SCHEME_NAME_SUCCESS,
      failedAction: FETCH_SCHEME_NAME_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
      signal: signal,
    };
    makeAPICall(params);
  };
}

export function fetchSchemeType(obj, callback, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutSmbFiber`,
      dispatch,
      defaultAction: FETCH_SCHEME_TYPE,
      successAction: FETCH_SCHEME_TYPE_SUCCESS,
      failedAction: FETCH_SCHEME_TYPE_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
      signal: signal,
    };
    makeAPICall(params);
  };
}

export function triggerFetchTimeStampPayout(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutSmbFiber`,
      dispatch,
      type: "POST",
      headers: obj.headers,
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function fetchPayoutDashboardSmbAndFiber(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutSmbFiber`,
      dispatch,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function fetchPayoutCsvSmbAndFiber(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}payoutSmbFiber`,
      dispatch,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function fetchWirelinePlanCount(obj, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_WIRELINE_PLANCOUNT,
      successAction: FETCH_WIRELINE_PLANCOUNT_SUCCESS,
      failedAction: FETCH_WIRELINE_PLANCOUNT_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
    };
    makeAPICall(params);
  };
}

export function fetchWirelinePlanCsv(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_WIRELINE_PLAN_CSV,
      successAction: FETCH_WIRELINE_PLAN_CSV_SUCCESS,
      failedAction: FETCH_WIRELINE_PLAN_CSV_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function fetchWirelineEnterprisePerf(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_WIRELINE_ENT_PERF,
      successAction: FETCH_WIRELINE_ENT_PERF_SUCCESS,
      failedAction: FETCH_WIRELINE_ENT_PERF_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      // callback: callback
    };
    makeAPICall(params);
  };
}

export function fetchNewAcq(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_NEW_ACQ,
      successAction: FETCH_NEW_ACQ_SUCCESS,
      failedAction: FETCH_NEW_ACQ_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      // callback: callback
    };
    makeAPICall(params);
  };
}

export function fetchNewAcqCsv(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_NEW_ACQ_CSV,
      successAction: FETCH_NEW_ACQ_CSV_SUCCESS,
      failedAction: FETCH_NEW_ACQ_CSV_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function fetchUpgradeCsv(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_UPGRADE_CSV,
      successAction: FETCH_UPGRADE_CSV_SUCCESS,
      failedAction: FETCH_UPGRADE_CSV_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function fetchUpgradeByProduct(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}ed1AndEd2`,
      dispatch,
      defaultAction: FETCH_UPGRADE_BY_PRODUCT,
      successAction: FETCH_UPGRADE_BY_PRODUCT_SUCCESS,
      failedAction: FETCH_UPGRADE_BY_PRODUCT_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      // callback: callback
    };
    makeAPICall(params);
  };
}

export function fetchTimestampEd2(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}timestamped2`,
      dispatch,
      defaultAction: FETCH_TIMESTAMP,
      successAction: FETCH_TIMESTAMP_SUCCESS,
      failedAction: FETCH_TIMESTAMP_FAILED,
      type: "POST",
      headers: obj.headers,
      // params: obj.params,
      // callback: callback
    };
    makeAPICall(params);
  };
}

export function fetchShowAlertEd1() {
  return {
    type: SHOW_ALERT_ED1,
  };
}

export function hideAlertEd1() {
  return {
    type: HIDE_ALERT_ED1,
  };
}

export function toggleDateAlert() {
  return {
    type: TOGGLE_DATE_ALERT,
  };
}

export function toggleErrorAlert() {
  return {
    type: TOGGLE_ERROR_ALERT,
  };
}

export function resetEd1() {
  return {
    type: RESET_ED1,
  };
}

export function setSelectedData(payload) {
  return {
    type: SET_SELECTED_DATA,
    payload,
  };
}
